import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Tab,
  Nav,
  Table,
  Form as RForm,
  FloatingLabel,
} from "react-bootstrap";

import Header from "../../../Header";
import Back from "../../UI/Back";
import Button from "../../UI/Button";
import StatusModal from "../../UI/StatusModal";
import useHideShowDropDown from "../../../helpers/hideshowdropdown";
import { useRef } from "react";
import { Formik, Form } from "formik";
import * as commonData from "../../../Common";
import * as Yup from "yup";
import CreateTable from "react-select/creatable";
import ColorCompo from "../../UI/ColorCompo";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import action from "../../../Actions";
import StatusRepeat from "./StatusRepeat";
import Loading from "../../UI/Loading";
import Message from "../../UI/Message";
import { useParams } from "react-router-dom";
import BoardListing from "../../attributeset/BoardListing/BoardListing";
import Modal from "../../UI/modal/Modal";
import NewModal from "../../UI/NewModal";
import Error from "../../Error";
import AttributePropertiseManagement from "./AttributePropertiseManagement";
import ReactSelect from "react-select";

const TattleSettings = (props) => {
  const dispatch = useDispatch();
  const param = useParams();
  const state = useSelector((state) => state);
  const [showModal, setShowModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showModalWorkflow, setShowModalWorkflow] = useState(false);
  const [editStatusList, setEditStatusList] = useState({});
  const [editStatusCatList, setEditStatusCatList] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [statusList, setStatusList] = useState(state.statusworkflow.status);
  const [statusCategoryList, setStatusCategoryList] = useState({});
  const [statusCategoryOptions, setStatusCategoryOptions] = useState({});
  const [loginDetails, setLoginDetails] = useState(state.loginDetails);
  const [deleteCategory, setDeleteCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState({
    info: { ...commonData.getCommonData() },
    boards: [],
    boardsData: {},
    deactive_boards: [],
    showModalEdit: false,
    deactivateModal: false,
    deactivateKey: "",
    isDeactivate: false,
    renameBoard: {},
    deleteModal: false,
    confirmDeleteBoard: false,
    attributePropertise: [],
  });
  const [toast, setToast] = useState({
    board: state.statusworkflow.board,
    position: "bottom-end",
    message: state.statusworkflow.message,
    title: state.statusworkflow.statusType,
    bg: "",
    code: "",
  });
  const [commondata, setCommonData] = useState({});
  const [boardData, setBoardData] = useState({});
  const [addCategory, setAddCategory] = useState([]);
  const [newcatIds, setNewIds] = useState([]);
  const [workflowcategory, setWorkflowcategory] = useState(
    state.statusworkflow.category
  );
  const [workflowdata, setWorkFlowData] = useState(
    state.statusworkflow.workflow
  );
  const [stateLogin, setStateLogin] = useState({});
  const [added_workflow_categories, setAddedWorkflowCategories] = useState([]);
  const [statusBoardDetails, setStatusBoardDetails] = useState(
    state.statusworkflow?.status_board_details
  );
  const [singleEditWorkFlow, setSingleEditWorkFlow] = useState({});
  const [stateData, setState] = useState({
    boards: [],
    tattleBoard: {
      error: {},
      board_name: "",
      attribute_set_type: 6,
      boardModal: false,
    },
    attributes: [],
  });
  const statusmodal = useRef(null);
  const statuscatmodal = useRef(null);
  let sel = useRef(null);


  const statusOptions = statusList.map(item => ({
    label: item.name,
    value: item._id,
  }));

  const groupCat = [
  { label: "Dev", value: "Dev" },
  { label: "QA", value: "QA" },
];

  // handle select react

  const handleChangeSelect = (opt, ev) => {
    if (ev.action == "create-option") {
      dispatch(
        action.status.createSingleCategory({
          app_token: commondata.app_token,
          user_uuid: commondata.user_uuid,
          attribute_set_key: props.match.params.attribute_set_key,
          category: { name: ev.option.value },
        })
      );
    }

    if (ev.action === "remove-value" && isEdit) {
      const removedId = ev.removedValue._id;

      const singleeditcat = singleEditWorkFlow?.category_ids?.filter(
        (it) => it._id !== removedId
      );
      if (singleeditcat !== undefined) {
        setSingleEditWorkFlow((prevState) => {
          return { ...prevState, category_ids: singleeditcat };
        });
      }
    }
    if (isEdit && ev.action === "select-option") {
      const categoringaddform = [...addCategory];
      categoringaddform.push(ev.option._id);
      setAddCategory(categoringaddform);
      const editsingleworkflowcat = { ...singleEditWorkFlow };
      editsingleworkflowcat?.category_ids?.push(ev.option);
      setSingleEditWorkFlow(editsingleworkflowcat);
    }

    if (ev.action === "select-option" && !isEdit) {
      const categoringaddform = [...addCategory];
      categoringaddform.push(ev.option._id);
      setAddCategory(categoringaddform);
    }
    if (ev.action === "remove-value" && !isEdit) {
      const categoringaddform = [...addCategory];
      const newcate = categoringaddform.filter(
        (ca) => ca !== ev.removedValue._id
      );
      setAddCategory(newcate);
    }
  };

  useEffect(() => {
    var title = props.title ? props.title : "";
    document.title = `${statusBoardDetails.attribute_set_name} | ${title}`;
  }, [statusBoardDetails]);

  useHideShowDropDown(statusmodal, () => {
    setShowModal(false);
    setShowModalWorkflow(false);
    setShowCategoryModal(false);
  });

  useEffect(() => {
    setLoginDetails(state.loginDetails);
  }, [state.loginDetails]);
  const getChildBoardApi = async (key) => {
    const data = commonData.getCommonData();
    const url = commonData.commonData().apiUrl;
    if (key === "fifth") {
      const response = await fetch(`${states.info.apiUrl}boards`, {
        method: "POST",
        body: JSON.stringify({
          app_token: states.info.app_token,
          attribute_set_key: param.attribute_set_key,
        }),
      });

      const rdata = await response.json();
      console.log(rdata, 6546489789778);
      const { code, data } = rdata;
      if (code === 200) {
        setStates((prevSt) => {
          return {
            ...prevSt,
            boards: data.active_board,
            deactive_boards: data.inactive_board,
          };
        });
      }
    }

    if (key === "first") {
      const response = await fetch(`${url}attribute/properties`, {
        method: "POST",
        body: JSON.stringify({
          app_token: data.app_token,
          attribute_set_key: props.match.params.attribute_set_key,
        }),
      });

      const rdata = await response.json();
      if (rdata.code == 200) {
        setTimeout(() => {
          setState((state) => {
            return {
              ...state,
              attributes: rdata.data,
            };
          });
        }, 100);

        const fetchattrpropertise = await fetch(`${url}/attribute-propertise`);
        if (fetchattrpropertise.ok) {
          const resdata = await fetchattrpropertise.json();
          setState((state) => {
            return {
              ...state,
              attributePropertise: resdata,
            };
          });
        }
      }
    }
  };

  useEffect(() => {
    const data = commonData.getCommonData();
    const url = commonData.commonData().apiUrl;
    dispatch(
      action.getBoardStatusDetails({
        app_token: data.app_token,
        attribute_set_key: props.match.params.attribute_set_key,
        user_uuid: data.user_uuid,
      })
    );

    dispatch(action.checkLinkForSideMenu(props.match.params.attribute_set_key));
    dispatch(
      action.status.getAllStatus({
        app_token: data.app_token,
        attribute_set_key: props.match.params.attribute_set_key,
      })
    );
    dispatch(
      action.status.getAllCategory({
        app_token: data.app_token,
        attribute_set_key: props.match.params.attribute_set_key,
      })
    );

    dispatch(
      action.status.getAllWorkflow({
        app_token: data.app_token,
        attribute_set_key: props.match.params.attribute_set_key,
      })
    );
    setCommonData((state) => {
      return {
        ...state,
        ...data,
      };
    });
    (async () => {
      setLoading(true);
      const response = await fetch(`${url}tattle/attributes`, {
        method: "POST",
        body: JSON.stringify({
          app_token: data.app_token,
          attribute_set_key: props.match.params.attribute_set_key,
        }),
      });

      const rdata = await response.json();
      setLoading(false);
      if (rdata.code == 200) {
        setState((state) => {
          return {
            ...state,
            attributes: rdata.data,
          };
        });

        const fetchattrpropertise = await fetch(`${url}attribute/properties`);
        if (fetchattrpropertise.ok) {
          const resdata = await fetchattrpropertise.json();
          setState((state) => {
            return {
              ...state,
              attributePropertise: resdata,
            };
          });
        }
      }
    })();
  }, []);

  const getAllStatusCategory = async () => {
    const url = commonData.getCommonData().apiUrl;

    try {
      const response = await fetch(`${url}system/status_cat/list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          app_token: commonData.getCommonData().app_token,
          attribute_set_key: props.match.params.attribute_set_key,
        }),
      });

      const rdata = await response.json();
      console.log("res344", rdata);

      if (rdata.code === 200 && Array.isArray(rdata.data?.all_records)) {
        setStatusCategoryList(rdata.data.all_records);
      } else {
        console.error("Unexpected response:", rdata);
      }
    } catch (error) {
      console.error("Error fetching group status:", error.message);
    }
  };


  useEffect(() => {
    getAllStatusCategory()
  }, []);

  useEffect(() => {
    if (statusCategoryList?.length) {
      const formattedOptions = statusCategoryList.map(item => ({
        label: item.name,
        value: item.name,
      }));
      setStatusCategoryOptions(formattedOptions);
    }
  }, [statusCategoryList]);



  useEffect(() => {
    setStatusList(state.statusworkflow.status);
  }, [state.statusworkflow.status]);



  useEffect(() => {
    setWorkflowcategory(state.statusworkflow.category);
    if (state.statusworkflow.board === true) {
      // setToast((prevState) => {
      //   return {
      //     ...prevState,
      //     board: true,
      //     message: state.statusworkflow.message,
      //     title: state.statusworkflow.statusType,
      //     bg: state.statusworkflow.code === 200 ? "primary" : "danger",
      //   };
      // });
    }

    if (state.statusworkflow.clearCategory) {
      setAddCategory([]);
    }
    const addcate = [...addCategory];
    addcate.push(state.statusworkflow.newcategory._id);
    if (
      state.statusworkflow.newcategory._id !== null &&
      state.statusworkflow.newcategory._id !== undefined
    ) {
      setAddCategory(addcate);
    } else {
      return;
    }
  }, [state.statusworkflow.board, state.statusworkflow.category]);

  useEffect(() => {
    setWorkFlowData(state.statusworkflow.workflow);
  }, [state.statusworkflow.workflow]);
  useEffect(() => {
    setAddedWorkflowCategories(state.statusworkflow.workflow_categories);
  }, [state.statusworkflow.workflow_categories]);

  useEffect(() => {
    if (state.statusworkflow.status_board_details) {
      setStatusBoardDetails(state.statusworkflow?.status_board_details);
    }
  }, [state.statusworkflow.status_board_details]);
  useEffect(() => {
    setShowModalWorkflow(state.statusworkflow.modal || false);
  }, [state.statusworkflow.workflow]);


  const updateStatusList = (obj) => {
    const statusdata = [...statusList, obj];
    const newdata = {
      app_token: commondata.app_token,
      user_uuid: commondata?.user_uuid,
      attribute_set_key: props.match.params.attribute_set_key,
      status: { name: obj.name, color: obj.color, status_category: obj.status_category ?? "" },
    };

    dispatch(action.status.createStatus(newdata));
  };

  const updateStatusCatList = async (obj) => {
    const newdata = {
      app_token: commondata.app_token,
      user_uuid: commondata?.user_uuid,
      attribute_set_key: props.match.params.attribute_set_key,
      status_cat: { name: obj.name, color: obj.color, status: obj.status, showInReport: obj.showInReport, groupCat: obj.groupCat },
    };

    const url = commonData.commonData().apiUrl;

    try {
      const response = await fetch(`${url}system/status_cat/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newdata),
      });

      const rdata = await response.json();

      if (rdata.code === 200 && rdata.data?.status_cat) {
        setStatusCategoryList((prev) => [...prev, rdata.data.status_cat]);
      } else {
        console.error("Unexpected response:", rdata);
      }
    } catch (error) {
      console.error("Error updating group status:", error.message);
    }
  };


  const editStatus = (index) => {
    const editList = [...statusList];
    setEditStatusList({ ...editList[index], index: index });
    setShowModal(true);
  };

  const editCatStatus = (index) => {
    const editCatList = [...statusCategoryList];
    setEditStatusCatList({ ...editCatList[index], index: index });
    setShowCategoryModal(true);
  };

  const editStatusFun = (data) => {
    const newdta = [...statusList];
    newdta[data.index] = data;
    const editStatus = {
      app_token: commondata.app_token,
      user_uuid: commondata.user_uuid,
      attribute_set_key: props.match.params.attribute_set_key,
      system_id: newdta[data.index]._id,
      status: {
        name: data.name,
        color: data.color,
        status_category: data.status_category ?? '',
      },
    };
    dispatch(action.status.updateStatus(editStatus));
    setStatusList(newdta);
  };

  const editStatusCatFun = async (data) => {
    try {
      const newList = [...statusCategoryList];
      newList[data.index] = { ...newList[data.index], ...data };

      const editStatus = {
        app_token: commondata.app_token,
        user_uuid: commondata.user_uuid,
        attribute_set_key: props.match.params.attribute_set_key,
        system_id: newList[data.index]._id,
        status_cat: {
          name: data.name,
          color: data.color,
          status: data.status,
          showInReport: data.showInReport,
          groupCat: data.groupCat
        },
      };

      const response = await fetch(`${commondata.apiUrl}system/status_cat/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editStatus),
      });

      const rdata = await response.json();

      if (response.ok) {
        // ✅ Update local list after successful API update
        setStatusCategoryList(newList);
        console.log("group status updated successfully:", rdata);
      } else {
        console.error("Update failed:", rdata);
      }
    } catch (err) {
      console.error("Error updating group status:", err);
    }
  };



  const addingStatus = () => {
    setShowModal(true);
    setShowCategoryModal(false);
    setEditStatusList("");

  };

  const addingStatusCategory = () => {
    setIsEdit(false);
    setEditStatusCatList({});
    setShowCategoryModal((prevState) => ({
      ...prevState,
      showCategoryModal: !prevState.showCategoryModal,
    }));
  };

  const addingWorkflow = () => {
    setIsEdit(false);
    setShowModalWorkflow((prevState) => ({
      ...prevState,
      showModalWorkflow: !prevState.showModalWorkflow,
    }));
    setSingleEditWorkFlow("");
  };
  const statusValidation = Yup.object({
    name: Yup.string().required("status name is required"),
    color: Yup.string().required("status name is required"),
  });
  const statusCatValidation = Yup.object({
    name: Yup.string().required("category name is required"),
    color: Yup.string().required("category name is required"),
  });
  const workflowValidation = Yup.object({
    workflow_name: Yup.string().required("workflow name is required"),
  });
  const defaultValue = (options, value) => {
    return options ? options.find((option) => option.value === value) : "";
  };
  const createOption = (value) => {
    return {
      value,
      label: value,
      key: value,
    };
  };
  const onCreateWorkFlow = (value) => {
    const createworkflow = {
      app_token: commondata.app_token,
      user_uuid: commondata.user_uuid,
      attribute_set_key: props.match.params.attribute_set_key,
      category_ids: addCategory,
      workflow_name: value.workflow_name,
    };
    dispatch(action.status.createWorkflow(createworkflow));
    setAddCategory([]);
    setSingleEditWorkFlow("");
  };
  const editWorkflow = (index) => {
    setIsEdit(true);
    setShowModalWorkflow(true);
    const editworkflow = [...workflowdata];
    const findworkflow = editworkflow.find((itm) => itm.workflow_id === index);
    setSingleEditWorkFlow({ ...findworkflow });
  };

  const updatesingleworkflow = (value) => {
    const editwork = [...workflowdata];
    editwork[value.index] = value;
    const inputedit = {
      workflow_id: value.workflow_id,
      category_ids: value.category_ids.map((it) => it._id),
      workflow_name: value.workflow_name,
      attribute_set_key: props.match.params.attribute_set_key,
    };
    dispatch(action.status.updateWorkfloeSingle(inputedit));
  };

  const changeConfiguration = async (evt) => {
    const url = commonData.commonData().apiUrl;
    const { name, checked } = evt.target;
    if (checked) {
      try {
        const detailsboard = { ...statusBoardDetails };
        detailsboard[name] = checked;
        setStatusBoardDetails(detailsboard);
        const response = await fetch(`${url}system/${name}/create`, {
          method: "post",
          body: JSON.stringify({
            app_token: commondata.app_token,
            user_uuid: commondata.user_uuid,
            attribute_set_key: props.match.params.attribute_set_key,
          }),
        });

        const rdata = await response.json();
        if (rdata.code === 200) {
          // setToast((toast) => {
          //   return {
          //     ...toast,
          //     message: rdata.message,
          //     title: rdata.status,
          //     board: true,
          //     bg: "primary",
          //   };
          // });
        } else {
          setToast((toast) => {
            return {
              ...toast,
              message: rdata.message,
              title: rdata.status,
              board: true,
              bg: "danger",
            };
          });
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      const detailsboard = { ...statusBoardDetails };
      detailsboard[name] = checked;
      setStatusBoardDetails(detailsboard);
      try {
        const response = await fetch(`${url}system/${name}/update`, {
          method: "post",
          body: JSON.stringify({
            app_token: commondata.app_token,
            user_uuid: commondata.user_uuid,
            attribute_set_key: props.match.params.attribute_set_key,
            [name]: checked === false ? 0 : 1,
          }),
        });

        const rdata = await response.json();
        if (rdata.code === 200) {
          // setToast((toast) => {
          //   return {
          //     ...toast,
          //     message: rdata.message,
          //     title: rdata.status,
          //     board: true,
          //     bg: "primary",
          //   };
          // });
        } else {
          setToast((toast) => {
            return {
              ...toast,
              message: rdata.message,
              title: rdata.status,
              board: true,
              bg: "danger",
            };
          });
        }
      } catch (error) {
        console.log(error.message);
      }
    }
  };
  const closeModal = (key) => {
    if (key === "status") {
      setShowModal((state) => {
        return { ...state, showModal: !state.showModal };
      });
    }
    if (key === "workflow") {
      setShowModalWorkflow(false); // This should set to false
    }
    if (key === "categorymodal") {
      setShowCategoryModal((state) => {
        return { ...state, showCategoryModal: !state.showCategoryModal };
      });
    }

    setStates((state) => {
      return {
        ...state,
        deleteModal: false,
        deactivateModal: false,
      };
    });
  };

  const addBoardHandler = () => {
    setState((prev) => {
      return {
        ...prev,
        tattleBoard: {
          ...prev.tattleBoard,
          boardModal: true,
        },
      };
    });
  };

  const hideBoardModal = () => {
    setState((prev) => {
      return {
        ...prev,
        tattleBoard: {
          ...prev.tattleBoard,
          boardModal: false,
          board_name: "",
        },
      };
    });
  };
  const activateBoardHandler = async (index, key) => {
    const activeBoards = [...states.boards];
    const deactive_Boards = [...states.deactive_boards];

    const getIndex = deactive_Boards.findIndex(
      (item) => item.attribute_set_key === key
    );

    if (getIndex >= 0) {
      const resp = await fetch(`${states.info.apiUrl}board-update`, {
        method: "post",
        body: JSON.stringify({
          app_token: states.info.app_token,
          user_uuid: states.info.user_uuid,
          attribute_set_key: key,
          attribute_set_status: 1,
        }),
      });
      const rdata = await resp.json();
      const { code } = rdata;
      if (code === 200) {
        // setToast((toast) => {
        //   return {
        //     ...toast,
        //     message: "Board activate successfully",
        //     title: rdata.status,
        //     board: true,
        //     bg: "primary",
        //   };
        // });
      }
      console.log(rdata, "new file new");
      let deactiveBoards = deactive_Boards.splice(getIndex, 1);
      activeBoards.push(deactiveBoards[0]);

      setStates((prev) => {
        return {
          ...prev,
          boards: activeBoards,
          deactive_boards: deactive_Boards,
        };
      });
    }
  };
  const editBoardNameHandler = (index, name, key) => {
    setStates((prev) => {
      return {
        ...prev,
        showModalEdit: true,
        renameBoard: { ...states.renameBoard, name: name, key: key },
      };
    });
  };
  useEffect(() => {
    (async () => {
      const deactiveboardsState = [...states.deactive_boards];

      const activeboards = [...states.boards];

      const indexfind = activeboards.findIndex(
        (item) => item.attribute_set_key === states.deactivateKey
      );
      if (states.isDeactivate) {
        if (indexfind) {
          const resp = await fetch(`${states.info.apiUrl}board-update`, {
            method: "post",
            body: JSON.stringify({
              app_token: states.info.app_token,
              user_uuid: states.info.user_uuid,
              attribute_set_key: states.deactivateKey,
              attribute_set_status: 0,
            }),
          });
          const rdata = await resp.json();
          const { code, data } = rdata;
          if (code === 200) {
            const deactiveboards = activeboards.splice(indexfind, 1);
            deactiveboardsState.push(deactiveboards[0]);

            // setToast((toast) => {
            //   return {
            //     ...toast,
            //     message: "Board deactivate successfully",
            //     title: rdata.status,
            //     board: true,
            //     bg: "primary",
            //   };
            // });
            setStates((prev) => {
              return {
                ...prev,
                boards: activeboards,
                deactive_boards: deactiveboardsState,
                isDeactivate: false,
                deactivateModal: false,
              };
            });
          }
        }
      }
    })();
  }, [states.isDeactivate]);

  const deactivateBoardHandler = () => {
    setStates((state) => {
      return {
        ...state,
        isDeactivate: true,
      };
    });
  };
  const sortAttributesField = async (result) => {
    const srcIn = result.source.index;
    const desIn = result.destination.index;

    const { attributes } = stateData;
    const srcvalue = attributes.splice(srcIn, 1);
    attributes.splice(desIn, 0, srcvalue[0]);

    setState((state) => {
      return {
        ...state,
        attributes,
      };
    });
    const datares = {
      app_token: states.info.app_token,
      attribute_set_key: param.attribute_set_key,
      user_uuid: states.info.user_uuid,
      attributes: attributes.map((it) => it.field),
    };
    const response = await fetch(
      `${commonData.getCommonData().apiUrl}attribute/sequence`,
      {
        method: "POST",
        body: JSON.stringify(datares),
      }
    );
  };

  const onBoardCreateHandler = async (evt) => {
    evt.preventDefault();
    const { board_name, attribute_set_type } = { ...stateData.tattleBoard };
    console.log(board_name, "test board name963963");
    const error = { ...stateData.tattleBoard.error };
    const regex = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (board_name.trim().length === 0) {
      error["board_name"] = "Board name can't be blank";
      setState((state) => {
        return {
          ...state,
          tattleBoard: {
            ...state.tattleBoard,
            error: { ...stateData.tattleBoard.error, ...error },
          },
        };
      });
      return;
    } else if (regex.test(board_name.trim())) {
      error["board_name"] = "Special character not allowed";
      setState((state) => {
        return {
          ...state,
          tattleBoard: {
            ...state.tattleBoard,
            error: { ...stateData.tattleBoard.error, ...error },
          },
        };
      });
      return;
    } else if (attribute_set_type.length === 0) {
      error["attribute_set_type"] = "Board type can't be blank";
      setState((state) => {
        return {
          ...state,
          tattleBoard: {
            ...state.tattleBoard,
            error: { ...stateData.tattleBoard.error, ...error },
          },
        };
      });
      return;
    } else {
      error["board_name"] = "";
      setState((state) => {
        return {
          ...state,
          tattleBoard: {
            ...state.tattleBoard,
            error: { ...stateData.tattleBoard.error, ...error },
          },
        };
      });
    }

    const craeteChildBoard = {
      app_token: states.info.app_token,
      user_uuid: states.info.user_uuid,
      board_name: stateData.tattleBoard.board_name,
      parent_attribute_set_key: param.attribute_set_key,
      attribute_set_type: stateData.tattleBoard.attribute_set_type,
      color: commonData.getRandomColor(),
    };

    const resp = await fetch(`${states.info.apiUrl}board/create`, {
      method: "post",
      body: JSON.stringify(craeteChildBoard),
    });

    const rdata = await resp.json();
    const { code, data } = rdata;
    if (code === 200) {
      // setToast((toast) => {
      //   return {
      //     ...toast,
      //     message: rdata.message,
      //     title: rdata.status,
      //     board: true,
      //     bg: "primary",
      //   };
      // });
      const boardsnew = [...states.boards];
      boardsnew.push(data);
      setStates((state) => {
        return {
          ...state,
          boards: boardsnew,
        };
      });
      setState((state) => {
        return {
          ...state,
          tattleBoard: {
            ...state.tattleBoard,
            boardModal: false,
            board_name: "",
          },
        };
      });
    } else {
      setToast((toast) => {
        return {
          ...toast,
          message: rdata.message,
          title: rdata.status,
          board: true,
          bg: "danger",
        };
      });
    }
    console.log(rdata, "iopopopopop");
  };
  const onBoardHandlerChange = (evt) => {
    const { name, value } = evt.target;
    setState((prev) => {
      return {
        ...prev,
        tattleBoard: {
          ...prev.tattleBoard,
          [name]: value,
        },
      };
    });
  };
  const nameOnChangeHandler = async (board) => {
    console.log(board, "nice kok");
    try {
      const response = await fetch(`${states.info.apiUrl}board/update`, {
        method: "post",
        body: JSON.stringify({
          app_token: states.info.app_token,
          user_uuid: states.info.user_uuid,
          attribute_set_name: board.name,
          attribute_set_key: board.set_key,
        }),
      });
      const rdata = await response.json();
      if (rdata.code === 200) {
        console.log(states.boards, "ni ok ni");
        const boards = [...states.boards];
        const getdata = boards.find(
          (itt) => itt.attribute_set_key === board.set_key
        );
        getdata["attribute_set_name"] = board.name;
        setStates((prev) => {
          return {
            ...prev,
            getdata,
          };
        });
        // console.log(rdata, "nice okok");
        // setToast({
        //   title: rdata.status,
        //   message: rdata.message,
        //   board: true,
        //   bg: "primary",
        //   position: "bottom-end",
        // });
        setStates((prev) => {
          return {
            ...prev,
            showModalEdit: false,
          };
        });
      } else {
        // this.setState((state) => {
        //   return {
        //     ...state,
        //     createBoard: {
        //       ...state.createBoard,
        //       title: "Board",
        //       message: rdata.message,
        //       board: true,
        //       bg: "danger",
        //     },
        //     showModalEdit: true,
        //   };
        // });
      }
    } catch (eror) {
      console.log(eror.message);
    }
  };

  const deactivateBoard = async (index, key) => {
    setStates((state) => {
      return {
        ...state,
        deactivateModal: true,
        deactivateKey: key,
      };
    });
  };

  const deleteBoardHandler = async (index, key, type) => {
    setStates((state) => {
      return {
        ...state,
        deleteModal: true,
        boardsData: { ...state.boardsData, index: index, key: key, type: type },
      };
    });
  };

  const confirmDeleteBoardHandler = async () => {
    console.log(states.boardsData, "board data 968959");
    const { index, key, type } = states.boardsData;

    const active_boards = [...states.boards];
    const deactivate_boards = [...states.deactive_boards];
    if (type === "active") {
      const findIndex = active_boards.findIndex(
        (ite) => ite.attribute_set_key === key
      );
      if (findIndex >= 0) {
        const resp = await fetch(`${states.info.apiUrl}board-update`, {
          method: "post",
          body: JSON.stringify({
            app_token: states.info.app_token,
            user_uuid: states.info.user_uuid,
            attribute_set_key: key,
            attribute_set_status: 2,
          }),
        });
        active_boards.splice(findIndex, 1);
        const rdata = await resp.json();

        const { code } = rdata;
        if (code === 200) {
          active_boards.splice(findIndex, 1);
          setStates((state) => {
            return {
              ...state,
              boards: active_boards,
              deleteModal: false,
            };
          });
        }
      }
    } else {
      const findIndex = deactivate_boards.findIndex(
        (ite) => ite.attribute_set_key === key
      );
      if (findIndex >= 0) {
        const resp = await fetch(`${states.info.apiUrl}board-update`, {
          method: "post",
          body: JSON.stringify({
            app_token: states.info.app_token,
            user_uuid: states.info.user_uuid,
            attribute_set_key: key,
            attribute_set_status: 2,
          }),
        });
        deactivate_boards.splice(findIndex, 1);
        setStates((prev) => {
          return {
            ...prev,
            deactive_boards: deactivate_boards,
          };
        });
        const rdata = await resp.json();

        const { code } = rdata;
        if (code === 200) {
          setStates((state) => {
            return {
              ...state,
              deleteModal: false,
              boardsData: deactivate_boards,
            };
          });
        }
      }
    }
  };

  const onCheckBox = async (val) => {
    const url = commonData.commonData().apiUrl;
    const { name, checked } = val.target;
    const statuslist = [...statusList];
    const newstatuslist = statuslist.map((item) =>
      item._id === name
        ? { ...item, is_default: checked }
        : { ...item, is_default: false }
    );
    setStatusList(newstatuslist);
    const changeDefaultStatus = {
      app_token: commondata.app_token,
      user_uuid: commondata.user_uuid,
      attribute_set_key: props.match.params.attribute_set_key,
      system_id: name,
      status: {
        is_default: checked,
      },
    };

    try {
      const response = await fetch(`${url}system/status/update`, {
        method: "post",
        body: JSON.stringify(changeDefaultStatus),
      });
      const rdata = await response.json();
      if (rdata.code === 200) {
        // setToast((prevState) => ({
        //   ...prevState,
        //   message: rdata.message,
        //   title: rdata.status,
        //   bg: "primary",
        //   board: true,
        // }));
      } else {
        setToast((prevState) => ({
          ...prevState,
          message: rdata.message,
          title: rdata.status,
          bg: "danger",
          board: true,
        }));
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  let newworkflowCategory = [];
  if (workflowcategory?.length > 0) {
    // const categoryexist = state.statusworkflow.workflow_categories;
    // console.log("noe cate", categoryexist);
    newworkflowCategory = workflowcategory?.map((cat) => {
      if (added_workflow_categories !== undefined) {
        if (Object?.values(added_workflow_categories).includes(cat._id)) {
          return {
            ...cat,
            label: cat.name,
            value: cat._id,
            isdisabled: true,
          };
        } else {
          return {
            ...cat,
            label: cat.name,
            value: cat._id,
            isdisabled: false,
          };
        }
      } else {
        return {
          ...cat,
          label: cat.name,
          value: cat._id,
          isdisabled: false,
        };
      }
    });
  }

  return (
    <>
      {states.deactivateModal && (
        <Modal
          show={states.deactivateModal}
          className="confirm"
          close={closeModal}
        >
          <div className="deleteAlert">
            <p>Do you want to deactivate the Board?</p>
            <div className="actionDelete">
              <Button
                className="muBtn _blue"
                text="Yes"
                onClick={() => deactivateBoardHandler()}
              />{" "}
              &nbsp;
              <Button
                className="muBtn _red"
                text="Cancel"
                onClick={closeModal}
              />
            </div>
          </div>
        </Modal>
      )}
      {states.deleteModal && (
        <Modal show={states.deleteModal} className="confirm" close={closeModal}>
          <div className="deleteAlert">
            <p>Are you sure you want to remove?</p>
            <div className="actionDelete">
              <Button
                className="muBtn _blue"
                text="Yes"
                onClick={() => confirmDeleteBoardHandler()}
              />{" "}
              &nbsp;
              <Button
                className="muBtn _red"
                text="Cancel"
                onClick={closeModal}
              />
            </div>
          </div>
        </Modal>
      )}
      {states.showModalEdit && (
        <NewModal
          renameBoard={states.renameBoard}
          nameOnChangeHandler={nameOnChangeHandler}
        />
      )}
      {toast.board && <Message board={toast} />}
      {stateData.tattleBoard.boardModal && (
        <Modal
          show={stateData.tattleBoard.boardModal}
          close={hideBoardModal}
          className="content-listing"
        >
          <RForm className="form" onSubmit={onBoardCreateHandler}>
            <div class="inputbox-group">
              <label class="col-12">Board name</label>
              <input
                placeholder="Board name"
                type="text"
                name="board_name"
                value={stateData.tattleBoard.board_name}
                onChange={onBoardHandlerChange}
                class="input-cls form-control"
                autocomplete="off"
              />
              <div className="error-feedback">
                {stateData.tattleBoard.error["board_name"]}
              </div>
            </div>
            <div class="inputbox-group mt-3">
              <label class="col-12">Board Type</label>
              <select
                placeholder="Board Type"
                name="attribute_set_type"
                value={stateData.tattleBoard.attribute_set_type}
                onChange={onBoardHandlerChange}
                className="form-control"
              >
                <option value="6">Story</option>
                <option value="9">Task</option>
                <option value="7">Bug</option>
                <option value="8">Test Cases</option>
                <option value="1">Advance</option>
              </select>
              <div className="error-feedback">
                {stateData.tattleBoard.error["attribute_set_type"]}
              </div>
            </div>

            <Button
              text={props.boards?.loadcreate ? "Submiting..." : "Submit"}
              type="submit"
              className="muBtn _blue sm mt-3"
              isDisabled={props.boards?.loadcreate}
            />
          </RForm>
        </Modal>
      )}
      <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
        <Header
          brecum_name={{ name: "", link: "" }}
          brecum_page={boardData.attribute_set_name}
        />{" "}
        <Container fluid className="p-0">
          <div className="page-content pt-3 new-content-main">
            {showModal && (
              <Error>
                <StatusModal
                  refs={statusmodal}
                  closeModal={() => closeModal("status")}
                >
                  <Formik
                    initialValues={{
                      name: "",
                      color: "primary",
                      status_category: "",
                      ...editStatusList,
                    }}
                    onSubmit={(values, { resetForm }) => {
                      if (editStatusList !== "") {
                        editStatusFun(values);
                      } else {
                        updateStatusList(values);
                      }
                      resetForm({ values: "" });
                      setShowModal(false);
                    }}
                    validationSchema={statusValidation}
                  >
                    {(formik) => {
                      return (
                        <Form>
                          <div className="form-group">
                            <label className="mb-2 form-label _required">
                              Status Name
                            </label>
                            <input
                              type="text"
                              className="form-control mb-3"
                              placeholder="status name"
                              name="name"
                              autoComplete="off"
                              onChange={formik.handleChange}
                              value={formik.values.name}
                              isInvalid={!formik.values.name}
                              isValid={formik.values.name}
                            />
                          </div>

                          <div className="status_color mb-3">
                            {[
                              "primary",
                              "danger",
                              "warning",
                              "info",
                              "dark",
                              "secondary",
                              "success",
                            ].map((it, ind) => {
                              return (
                                <ColorCompo
                                  name="color"
                                  newfil={commonData.hexToRgba(it, 0.1)}
                                  value={commonData.hexToRgba(it, 0.1)?.key}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.color === it ? "checked" : ""
                                  }
                                  defaultChecked={ind === 0 ? "checked" : ""}
                                  textValue={formik.values.name}
                                />
                              );
                            })}
                          </div>

                          {/* Group status */}
                          {/* <div className="mb-3">
                            <label className="col-12 mb-2 form-label">
                              Group status
                            </label>
                            <ReactSelect
                              options={statusCategoryOptions}
                              maxMenuHeight={175}
                              isClearable={true}
                              value={
                                formik.values.status_category
                                  ? {
                                    label: formik.values.status_category
                                      .charAt(0)
                                      .toUpperCase() +
                                      formik.values.status_category.slice(1),
                                    value: formik.values.status_category,
                                  }
                                  : null
                              }
                              name="status_category"
                              placeholder="Select Group status"
                              onChange={(option) =>
                                formik.setFieldValue("status_category", option ? option.value : "")
                              }
                              components={{
                                ClearIndicator: (props) => (
                                  <div
                                    {...props.innerProps}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.clearValue();
                                    }}
                                  >
                                    ×
                                  </div>
                                ),
                              }}
                            />
                          </div> */}

                          <Button className="muBtn _blue" type="submit">
                            Submit
                          </Button>
                        </Form>
                      );
                    }}
                  </Formik>
                </StatusModal>
              </Error>
            )}
            {showCategoryModal && (
              <Error>
                <StatusModal
                  refs={statusmodal}
                  closeModal={() => closeModal("categorymodal")}
                >
                  <Formik
                    initialValues={{
                      name: "",
                      color: "primary",
                      status: [],
                      showInReport: false,
                      variable: "",
                      groupCat: "",
                      ...editStatusCatList,
                    }}
                    onSubmit={(values, { resetForm }) => {
                      console.log("editStatusCatList45", Object.keys(editStatusCatList).length);
                      if (Object.keys(editStatusCatList).length !== 0) {
                        editStatusCatFun(values);
                      } else {
                        updateStatusCatList(values);
                      }
                      resetForm({ values: "" });
                      setShowCategoryModal(false);
                    }}
                    validationSchema={statusCatValidation}
                  >
                    {(formik) => {
                      return (
                        <Form>
                          <div className="form-group">
                            <label className="mb-2 form-label _required">
                              Category Name
                            </label>
                            <input
                              type="text"
                              className="form-control mb-3"
                              placeholder="category name"
                              name="name"
                              autoComplete="off"
                              onChange={formik.handleChange}
                              value={formik.values.name}
                              isInvalid={!formik.values.name}
                              isValid={formik.values.name}
                            />
                          </div>

                          <div className="status_color mb-3">
                            {[
                              "primary",
                              "danger",
                              "warning",
                              "info",
                              "dark",
                              "secondary",
                              "success",
                            ].map((it, ind) => {
                              return (
                                <ColorCompo
                                  name="color"
                                  newfil={commonData.hexToRgba(it, 0.1)}
                                  value={commonData.hexToRgba(it, 0.1)?.key}
                                  onChange={formik.handleChange}
                                  checked={
                                    formik.values.color === it ? "checked" : ""
                                  }
                                  defaultChecked={ind === 0 ? "checked" : ""}
                                  textValue={formik.values.name}
                                />
                              );
                            })}
                          </div>

                          {/* {console.log(statusList, statusCategoryOptions, "ddffg")} */}
                          <div className="mb-3">
                            <ReactSelect
                              options={statusOptions} // [{ label, value }]
                              maxMenuHeight={175}
                              isClearable
                              isMulti
                              name="status"
                              placeholder="Select group status"
                              value={
                                Array.isArray(formik.values.status)
                                  ? statusOptions.filter(opt =>
                                    formik.values.status.includes(opt.value)
                                  )
                                  : []
                              }
                              onChange={(selected) =>
                                formik.setFieldValue(
                                  "status",
                                  selected ? selected.map(opt => opt.value) : []
                                )
                              }
                              components={{
                                ClearIndicator: (props) => (
                                  <div
                                    {...props.innerProps}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.clearValue();
                                    }}
                                  >
                                    ×
                                  </div>
                                ),
                              }}
                            />
                          </div>

                           <ReactSelect
                              options={groupCat}
                              maxMenuHeight={175}
                              isClearable={true}
                              value={
                                formik.values.groupCat
                                  ? {
                                    label: formik.values.groupCat
                                      .charAt(0)
                                      .toUpperCase() +
                                      formik.values.groupCat.slice(1),
                                    value: formik.values.groupCat,
                                  }
                                  : null
                              }
                              name="groupCat"
                              placeholder="Select Group status"
                              onChange={(option) =>
                                formik.setFieldValue("groupCat", option ? option.value : "")
                              }
                              components={{
                                ClearIndicator: (props) => (
                                  <div
                                    {...props.innerProps}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                      e.preventDefault();
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      props.clearValue();
                                    }}
                                  >
                                    ×
                                  </div>
                                ),
                              }}
                            />



                          <div className="form-check my-3">
                            <input
                              type="checkbox"
                              id="showInReport"
                              name="showInReport"
                              className="form-check-input"
                              checked={formik.values.showInReport}
                              onChange={formik.handleChange}
                            />
                            <label htmlFor="showInReport" className="form-check-label">
                              Show in Report
                            </label>
                          </div>



                          <Button className="muBtn _blue" type="submit">
                            Submit
                          </Button>
                        </Form>
                      );
                    }}
                  </Formik>
                </StatusModal>
              </Error>
            )}

            {showModalWorkflow && (
              <StatusModal
                refs={statusmodal}
                closeModal={() => closeModal("workflow")}
              >
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    workflow_name: "",
                    ...singleEditWorkFlow,
                  }}
                  onSubmit={(values, { resetForm }) => {
                    if (isEdit) {
                      updatesingleworkflow(values);
                    } else {
                      onCreateWorkFlow(values);
                    }
                  }}
                  validationSchema={workflowValidation}
                >
                  {(formik) => {
                    return (
                      <Form>
                        <div className="form-group">
                          <label className="mb-2 form-label _required">
                            Workflow Name
                          </label>
                          <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="workflow name"
                            name="workflow_name"
                            autoComplete="off"
                            value={formik.values.workflow_name}
                            onChange={formik.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label className="mb-2 form-label _required">
                            Category
                          </label>
                          <CreateTable
                            className="mb-3 abc"
                            isMulti
                            ref={sel}
                            name="workflow_category"
                            onChange={(opt, e) => handleChangeSelect(opt, e)}
                            options={newworkflowCategory}
                            isOptionDisabled={(option) => option.isdisabled}
                            value={singleEditWorkFlow?.category_ids
                              ?.filter((fitm) =>
                                newworkflowCategory?.filter(
                                  (nitm) => nitm?._id === fitm?._id
                                )
                              )
                              ?.map((mitm) => ({
                                ...mitm,
                                label: mitm?.name,
                                value: mitm?._id,
                              }))}
                          />
                        </div>

                        <Button className="muBtn _blue" type="submit">
                          Submit
                        </Button>
                      </Form>
                    );
                  }}
                </Formik>
              </StatusModal>
            )}

            <Row>
              <Col md={12}>
                <Card className="card cardTable">
                  <Card.Body>
                    <div className="status_workflow_main">
                      <div className="status_workflow_sidebar">
                        <div class="pt-3 pb-3 ps-3 border-bottom">
                          <div class="row gx-2 justify-content-end align-items-center">
                            <div class="col">
                              <div class="title pe-1">
                                {" "}
                                <Back
                                  to={`/board/list`}
                                  state={props.location.state}
                                  className="txt-dark underline-none"
                                />{" "}
                                Settings{" "}
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                        <div class="card border-0 border-bottom">
                          <div class="card-body">
                            <h5 class="title-sm">
                              Board Type :{" "}
                              {(state.statusworkflow.status_board_details
                                .attribute_set_type === 4 &&
                                "TODO") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 2 &&
                                  "Support Ticket") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 3 &&
                                  "ER") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 5 &&
                                  "Market Feedback") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 1 &&
                                  "Default Board") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 6 &&
                                  "Story") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 9 &&
                                  "Task") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 8 &&
                                  "Test Cases") ||
                                (state.statusworkflow.status_board_details
                                  .attribute_set_type === 7 &&
                                  "Bug")}
                            </h5>
                          </div>
                        </div>
                        <div className="status_workflow_secondary">
                          {" "}
                          <Tab.Container
                            defaultActiveKey="first"
                            onSelect={(key) => getChildBoardApi(key)}
                          >
                            <div className="status_worflow_left">
                              <Nav variant="pills" className="flex-column">
                                <Nav.Item>
                                  <Nav.Link
                                    eventKey="first"
                                    defaultActiveKey="first"
                                  >
                                    Manage Properties{" "}
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="second">Status</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="third">Workflow</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="fourth">
                                    {" "}
                                    System Attributes
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="fifth">Board</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                  <Nav.Link eventKey="sixth">Group status</Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </div>
                            <div className="status_workflow_right">
                              <Tab.Content>
                                <Tab.Pane eventKey="second">
                                  <div className="status_right_main">
                                    <div className="status_right_header">
                                      <div className="status_right_button mt-4">
                                        <Button
                                          className="muBtn _blue"
                                          onClick={addingStatus}
                                        >
                                          Add Status
                                        </Button>
                                        <div className="status_right_table statusdata">
                                          <Table>
                                            <thead>
                                              <tr>
                                                <th colSpan={3}>Status Name</th>
                                                <th>Default status</th>
                                                {/* <th>Category</th> */}
                                                <th style={{ width: 60 }}></th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {state.statusworkflow.loading ? (
                                                <Loading />
                                              ) : statusList?.length > 0 ? (
                                                statusList.map((it, index) => (
                                                  <StatusRepeat
                                                    status={it}
                                                    key={index}
                                                    editStatus={editStatus}
                                                    index={index}
                                                    onCheck={onCheckBox}
                                                  />
                                                ))
                                              ) : (
                                                <p className="d-flex align-items-center">
                                                  No status found
                                                </p>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="third">
                                  <div className="status_right_main">
                                    <div className="status_right_header">
                                      <div className="status_right_button mt-4">
                                        <Button
                                          className="muBtn _blue"
                                          onClick={addingWorkflow}
                                        >
                                          Add Workflow
                                        </Button>
                                        <div className="status_right_table workflow mt-3">
                                          <Table>
                                            <thead>
                                              <tr>
                                                <th>Workflow Name</th>
                                                <th>Category Name</th>
                                                <th>Created Date</th>
                                                <th></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {workflowdata?.length > 0
                                                ? workflowdata.map(
                                                  (it, index) => (
                                                    <StatusRepeat
                                                      workflow={it}
                                                      state={
                                                        props.location.state
                                                          ?.data
                                                      }
                                                      index
                                                      key={it.workflow_id}
                                                      editWorkflow={
                                                        editWorkflow
                                                      }
                                                      attributeset={
                                                        props.match.params
                                                          .attribute_set_key
                                                      }
                                                    />
                                                  )
                                                )
                                                : "No workflow found"}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="fourth">
                                  <div className="status_right_main">
                                    <div className="status_right_header">
                                      <div className="status_right_button mt-4">
                                        <div className="configuration_check">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="age"
                                            checked={statusBoardDetails.age}
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Age</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="reporter"
                                            checked={
                                              statusBoardDetails.reporter
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Reporter</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="assign_to"
                                            checked={
                                              statusBoardDetails.assign_to
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Assign To</span>
                                        </div>

                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="last_update_since"
                                            checked={
                                              statusBoardDetails.last_update_since
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Last Update Since</span>
                                        </div>

                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="monitoring"
                                            checked={
                                              statusBoardDetails.monitoring
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Monitoring</span>
                                        </div>

                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="account_manager"
                                            checked={
                                              statusBoardDetails.account_manager
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Account Manager</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="customer_type"
                                            checked={
                                              statusBoardDetails.customer_type
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Customer Type</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="company_name"
                                            checked={
                                              statusBoardDetails.company_name
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Company Name</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="name"
                                            checked={statusBoardDetails.name}
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Customer Name</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="attachment"
                                            checked={
                                              statusBoardDetails.attachment
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Attachment</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="customer"
                                            checked={
                                              statusBoardDetails.customer
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Customer</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="cc"
                                            checked={statusBoardDetails.cc}
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>CC</span>
                                        </div>
                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="er"
                                            checked={statusBoardDetails.er}
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>ER</span>
                                        </div>

                                        <div className="configuration_check mt-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            name="support-ticket"
                                            checked={
                                              statusBoardDetails[
                                              "support-ticket"
                                              ]
                                            }
                                            onChange={changeConfiguration}
                                          />{" "}
                                          &nbsp;
                                          <span>Ticket</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="fifth">
                                  <div className="px-4 py-4">
                                    <Row>
                                      <div className="title mb-3">Boards</div>
                                      {states.boards.map(
                                        (item, index) =>
                                          item.attribute_set_key !==
                                          param.attribute_set_key && (
                                            <Col xs={12} sm={6} md={4} lg={4}>
                                              <Error>
                                                <BoardListing
                                                  board_data={item}
                                                  setting={{
                                                    set_key:
                                                      item.attribute_set_key,
                                                  }}
                                                  deactivate={() =>
                                                    deactivateBoard(
                                                      index,
                                                      item.attribute_set_key
                                                    )
                                                  }
                                                  deleteBoard={() =>
                                                    deleteBoardHandler(
                                                      index,
                                                      item.attribute_set_key,
                                                      "active"
                                                    )
                                                  }
                                                  editName={() =>
                                                    editBoardNameHandler(
                                                      index,
                                                      item.attribute_set_name,
                                                      item.attribute_set_key
                                                    )
                                                  }
                                                  isAdmin={
                                                    +states.info.is_admin
                                                  }
                                                  deactive={true}
                                                />
                                              </Error>
                                            </Col>
                                          )
                                      )}
                                      {+states.info.is_admin === 1 && (
                                        <Col
                                          xs={12}
                                          sm={6}
                                          md={4}
                                          lg={4}
                                          onClick={addBoardHandler}
                                        >
                                          <div class="todo-input">
                                            <div class="left-div six-color">
                                              <span>
                                                <svg
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M9 7V0H7V7H0V9H7V16H9V9H16V7H9Z"
                                                    fill="#909090"
                                                  ></path>
                                                </svg>
                                              </span>
                                            </div>
                                            <div class="right-div">
                                              Create Child Board
                                            </div>
                                          </div>
                                        </Col>
                                      )}
                                    </Row>
                                    {states.deactive_boards.length > 0 && (
                                      <Row>
                                        <div className="title mb-3">
                                          Deactive Boards
                                        </div>
                                        {states.deactive_boards.map(
                                          (item, index) => (
                                            <Col xs={12} sm={6} md={4} lg={4}>
                                              <BoardListing
                                                board_data={item}
                                                active_board={() =>
                                                  activateBoardHandler(
                                                    index,
                                                    item.attribute_set_key
                                                  )
                                                }
                                                // deactivate={() =>
                                                //   deactivateBoard(
                                                //     index,
                                                //     item.attribute_set_key
                                                //   )
                                                // }
                                                setting={{
                                                  set_key:
                                                    item.attribute_set_key,
                                                }}
                                                deleteBoard={() =>
                                                  deleteBoardHandler(
                                                    index,
                                                    item.attribute_set_key,
                                                    "deactive"
                                                  )
                                                }
                                                // editName={() =>
                                                //   editBoardNameHandler(
                                                //     index,
                                                //     item.attribute_set_name,
                                                //     item.attribute_set_key
                                                //   )
                                                // }
                                                isAdmin={+states.info.is_admin}
                                                active={true}
                                              />
                                            </Col>
                                          )
                                        )}
                                      </Row>
                                    )}
                                  </div>
                                </Tab.Pane>
                                <Tab.Pane
                                  eventKey="first"
                                  style={{ height: "420px" }}
                                >
                                  {" "}
                                  {/* <DragDropContext
                                    onDragEnd={(result) =>
                                      sortAttributesField(result)
                                    }
                                  >
                                    <Droppable droppableId="droppable-1">
                                      {(provided, snapshot) => {
                                        return (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className="parentDivDrag"
                                          >
                                            {stateData.attributes.map(
                                              (itt, index) => (
                                                <Draggable
                                                  key={itt.field}
                                                  draggableId={itt.field}
                                                  index={index}
                                                >
                                                  {(provided, snapshot) => {
                                                    return (
                                                      <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className="dragClass"
                                                      >
                                                        {itt.headerName}
                                                      </div>
                                                    );
                                                  }}
                                                </Draggable>
                                              )
                                            )}
                                            {provided.placeholder}
                                          </div>
                                        );
                                      }}
                                    </Droppable>
                                  </DragDropContext> */}
                                  {!loading ? (
                                    <AttributePropertiseManagement
                                      attributes={stateData.attributes || []}
                                      attributePropertise={
                                        stateData.attributePropertise || []
                                      }
                                      loading={loading}
                                    />
                                  ) : (
                                    <Loading />
                                  )}
                                </Tab.Pane>
                                <Tab.Pane eventKey="sixth">
                                  <div className="status_right_main">
                                    <div className="status_right_header">
                                      <div className="status_right_button mt-4">
                                        <Button
                                          className="muBtn _blue"
                                          onClick={addingStatusCategory}
                                        >
                                          Add Group status
                                        </Button>
                                        <div className="status_right_table statusdata">
                                          <Table>
                                            <thead>
                                              <tr>
                                                <th colSpan={3}>Group status Name</th>\
                                                <th style={{ width: 60 }}></th>
                                              </tr>
                                            </thead>

                                            <tbody>
                                              {state.statusworkflow.loading ? (
                                                <Loading />
                                              ) : statusCategoryList?.length > 0 ? (
                                                statusCategoryList.map((it, index) => (
                                                  <StatusRepeat
                                                    category={it}
                                                    key={index}
                                                    editStatus={editCatStatus}
                                                    index={index}
                                                  // onCheck={onCheckBox}
                                                  />
                                                ))
                                              ) : (
                                                <p className="d-flex align-items-center">
                                                  No status found
                                                </p>
                                              )}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Tab.Pane>
                              </Tab.Content>
                            </div>
                          </Tab.Container>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default TattleSettings;
